<template>
    <div class="flex justify-content-center px-lg-5">
        <div class="">
            <div class="card bg-md-secondary bg-transparent shadow border-0">
                <div class="card-body px-lg-5 py-lg-5">
                    <div class="text-center text-muted mb-4">
                        <small>Saisissez votre mot de passe</small>
                    </div>

                    <form role="form">
                        <base-input class="input-group-alternative"
                                    placeholder="Mot de passe"
                                    type="password"
                                    addon-left-icon="ni ni-lock-circle-open"
                                    :valid="$v.model.password.$dirty ? !$v.model.password.$error : null"
                                    :error="($v.model.password.$dirty && $v.model.password.$error) ? (!$v.model.password.required ? $t('message.requiredField') : $t('message.minCharacters', { n: 6 })) : null"
                                    v-model="$v.model.password.$model"
                                    @click="clearErrorField('password')"
                        >
                        </base-input>

                        <base-input class="input-group-alternative"
                                    placeholder="confirmer votre mot de passe"
                                    type="password"
                                    addon-left-icon="ni ni-lock-circle-open"
                                    :valid="$v.model.password_confirmation.$dirty ? !$v.model.password_confirmation.$error : null"
                                    :error="($v.model.password_confirmation.$dirty && $v.model.password.$error) ? (!$v.model.password_confirmation.required ? $t('message.requiredField') : $t('message.minCharacters', { n: 6 })) : null"
                                    v-model="$v.model.password_confirmation.$model">
                        </base-input>
                        <div class="error" v-if="!$v.model.password_confirmation.sameAsPassword">Passwords must be identical.</div>
                        <div class="error" v-if="errorshasField('password')">{{getErrorsField('password')}}</div>


                        <div class="text-center">
                            <base-button type="primary" class="my-4" @click="submit">{{$t('message.submit')}}</base-button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import AppConfig from "../../constants/AppConfig";
    import {minLength, required,sameAs} from "vuelidate/lib/validators";
    import { mapGetters } from 'vuex';

    export default {
        name: "Reset",
        computed: {
            ...mapGetters(["errors"]),
        },

        data() {
            return {
                model: {
                    password_confirmation: '',
                    password: ''
                }
            }
        },

        methods: {
            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return '';
                }
            },

            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });

                this.getErrorsField(field);
            },

            invalidEmail: function() {
                if (this.$v.model.email.$dirty && this.$v.model.email.$error) {
                    return !this.$v.model.email.required ?
                        this.$i18n.t('message.requiredField') :
                        this.$i18n.t('message.emailNotValid');
                }

                return null;
            },

            submit: function() {
                this.$v.$touch();

                if(!this.$v.$invalid) {
                    let args = {
                        user:this.$route.params.user,
                        token:this.$route.params.token,
                        password_confirmation: this.model.password_confirmation,
                        password: this.model.password
                    };

                    this.$store.dispatch('resetHandler', { args });
                }
            }
        },

        validations: {
            model: {
                password_confirmation: {
                    sameAsPassword: sameAs('password')

                },

                password: {
                    required,
                    minLength: minLength(6)
                }
            }
        },

        watch: {
            $v: {
                handler: function (val) {
                    if(!val.$invalid) {
                        //
                    }
                }
            }
        }

    }
</script>

<style scoped>

</style>